import styled from 'styled-components/macro';
import {
  fontSize,
  fontWeight,
  layout,
  lineHeight,
  media,
  neutral,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';

export const Whiteboard = styled.section`
  background: ${neutral.surface};
  box-shadow: ${shadow.md};
  border-radius: 0 0 ${radius.lg} ${radius.lg};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${space[1]};
  width: 100vw;
  position: fixed;
  top: ${layout.mobileNavHeight};
  z-index: 10;
  padding: ${space[2]} ${layout.gutter} ${space[3]};
  ${media.md`
    top: 0;
    width: calc(100vw - ${layout.sidebarWidth});
    padding: ${space[3]} ${layout.gutterWide} ${space[4]};
  `}
`;

export const ClassroomTitle = styled.h1`
  margin: 0;
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.sm};
  line-height: ${lineHeight.tight};
  color: ${({ theme }) => theme.textDark};
  text-align: center;
  overflow-wrap: anywhere;
`;

export const CurrentModule = styled.h2`
  margin: 0;
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.md};
  line-height: ${lineHeight.tight};
  color: ${({ theme }) => theme.headerColour};
`;

export const WhiteboardContent = styled.p`
  max-width: ${layout.readableMaxWidth};
  text-align: center;
  margin: 0;
  font-style: normal;
  font-weight: ${fontWeight.medium};
  font-size: ${fontSize.lg};
  line-height: ${lineHeight.tight};
  white-space: pre-line;
  overflow-wrap: anywhere;
  color: #b40029;

  ${media.md`
    font-size: ${fontSize.xl};
  `}
`;
